import { Box, Stack, Typography } from "@mui/material";
import { useGetShippingAddressQuery } from "src/api/services/addressApi";
import EditPencilIcon from "src/assets/icons/EditPencilIcon";
import { useIsMobile } from "src/hooks/useIsMobile";
import WhiteCard from "src/shared/components/WhiteCard";
import EditAddressModal from "./components/EditAddressModal";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  page: string;
}

const AddressInformation = ({ page }: Props) => {
  const isMobile = useIsMobile();
  const { data: shippingAddress, isLoading } = useGetShippingAddressQuery();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const component = "addressCard";
  const { t } = useTranslation();

  if (isLoading) {
    return <Typography>Loading shipping address information...</Typography>;
  }

  return (
    <>
      <WhiteCard>
        <Stack direction="row" gap={3}>
          <Typography variant={isMobile ? "body1" : "h6"} fontWeight={600}>
            {t(`${page}.${component}.title`)}
          </Typography>
          <Box
            display="flex"
            alignItems="center"
            sx={{ gap: 0.5, cursor: "pointer" }}
            onClick={() => setOpenModal(true)}
          >
            <EditPencilIcon />
            <Typography sx={{ color: "#00B6B9" }}>
              {t(`${page}.edit`)}
            </Typography>
          </Box>
        </Stack>
        <Stack
          direction={isMobile ? "column" : "row"}
          justifyContent="space-between"
          gap={isMobile ? 2 : 0}
        >
          <Stack gap={0.5}>
            <Typography variant="subtitle1">
              {t(`${page}.${component}.full_address`)}
            </Typography>
            <Typography>{`${shippingAddress?.address_line1}${
              shippingAddress?.address_line2
                ? ", " + shippingAddress?.address_line2
                : ""
            }`}</Typography>
          </Stack>
          <Stack gap={0.5}>
            <Typography variant="subtitle1">
              {t(`${page}.${component}.city`)}
            </Typography>
            <Typography>{shippingAddress?.city}</Typography>
          </Stack>
          <Stack gap={0.5}>
            <Typography variant="subtitle1">
              {t(`${page}.${component}.state`)}
            </Typography>
            <Typography>{shippingAddress?.state}</Typography>
          </Stack>
          <Stack gap={0.5}>
            <Typography variant="subtitle1">
              {t(`${page}.${component}.zipcode`)}
            </Typography>
            <Typography>{shippingAddress?.zip_code}</Typography>
          </Stack>
        </Stack>
      </WhiteCard>
      <EditAddressModal
        shippingAddress={shippingAddress}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
    </>
  );
};

export default AddressInformation;
